import type { Action } from 'vuex'
import type { State } from './state'
import type { ApiKeyDetails } from '@/api/api_key/apiKeyModel'

import actionTypes from './actionTypes'

const actions: { [actionTypes: string]: Action<State, any> } = {
  [actionTypes.SET_MODAL_CONFIRM_API_KEY_ACTIVED]: (
    { commit },
    boolean: boolean
  ): void => {
    commit(actionTypes.SET_MODAL_CONFIRM_API_KEY_ACTIVED, boolean)
  },
  [actionTypes.SET_API_KEY_DATAS]: ({ commit }, data: Array<ApiKeyDetails>): void => {
    commit(actionTypes.SET_API_KEY_DATAS, data)
  },
}

export default actions
